import { UI_CURRENT_LANGUAGE, UI_DISPLAY_LANGUAGES, UiDisplayLanguage } from "@/types/UiDisplayLanguage"

const getPersistedLanguage = () => {
  // This line is used for component testing, which will be run in a container and without a browser
  if (typeof localStorage === "undefined") return UI_DISPLAY_LANGUAGES.ENGLISH

  const currentLanguage = localStorage.getItem(UI_CURRENT_LANGUAGE)
  if (!currentLanguage) {
    changeLanguage(UI_DISPLAY_LANGUAGES.ENGLISH)
    return UI_DISPLAY_LANGUAGES.ENGLISH
  }
  return currentLanguage
}

const changeLanguage = (lang: UiDisplayLanguage) => {
  return localStorage.setItem(UI_CURRENT_LANGUAGE, lang)
}

export { getPersistedLanguage, changeLanguage }
